import { BaseService } from './base-service';
import { lastValueFrom } from 'rxjs';
export class DossierStatusesService {
    // ----------------------------------------------------------------------
    // Dossier Statuses
    // ----------------------------------------------------------------------
    static getDossierStatuses(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`dossier-statuses?filter=${qs}`, pageNumber));
    }
    // public static fetchDossierStatus(oid: number) {
    //   return BaseService.get<IDossierStatus>(`dossier-statuses/${oid}`);
    // }
    static saveDossierStatus(dto) {
        return lastValueFrom(BaseService.save(`dossier-statuses`, dto));
    }
    static deleteDossierStatus(oid) {
        return lastValueFrom(BaseService.delete(`dossier-statuses/${oid}`));
    }
    static searchDossierStatusCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`dossier-statuses-combo/${selfId}?search=${qs}`));
    }
}
